import { createSelector } from "reselect";
import { createCachedSelector } from "re-reselect";

import { ROLE_TYPE_MAP } from "lib/constants";
// import rollbar from "lib/rollbar";

/**
 * Get questions from the state localized for the currently
 * selected language.
 */
export const localQuestions = createCachedSelector(
    (state) => state.questions.questions,
    (state, lang = null) => lang || state.i18nState.lang,
    (questions, lang) => {
        if (!lang || lang === "en") {
            // English is the always-present default
            return questions;
        }

        // If they have a language selected, we'll merge english and translated
        // questions together. We do this so that in cases where we add or
        // modify questions, we can continue showing the majority of the
        // check-in in the user's language, but still show any new questions
        // until they're fully translated.
        return questions.map((q) => {
            if (q[lang]) {
                // if (q.answer.length !== q[lang].answer.length) {
                //     rollbar.warn("Untranslated check-in question answers", {
                //         lang,
                //         question: q.id,
                //         answer: q.answer,
                //     });
                // }

                return {
                    ...q,
                    ...q[lang],
                };
            }

            // rollbar.warn("Untranslated check-in question", {
            //     lang,
            //     question: q.id,
            // });

            return q;
        });
    },
)((state, lang) => lang || state.i18nState.lang);

export const filterQuestions = createSelector(
    (state) => state.questions,
    (state) => state.answers,
    ({ questions, filters, current }, answers) => {
        if (current === null) {
            return questions;
        }

        let qs = questions.slice(current + 1);

        // Only unanswered. Temporary?
        // Used for a case where someone answers 1, 2, skips 3, answers 4, quits
        // then returns. We'll land them on 3, then need to skip 4 and land on 5.
        if (answers) {
            qs = qs.filter((q) => !answers[q.id]);
        }

        if (filters.roleType) {
            qs = qs.filter((q) => !q.role_type || ROLE_TYPE_MAP[q.role_type] & filters.roleType);
        }

        if (filters.preferences === false) {
            qs = qs.filter((q) => !String(q.id).startsWith("pref_"));
        }

        return qs;
    },
);

export const getCurrentQuestion = createSelector(
    (state, lang = null) => localQuestions(state, lang),
    ({ questions }) => questions.current,
    (questions, current) => (current !== null ? questions[current] : null),
);

export const answeredQuestions = createSelector(
    (questions) => questions,
    (questions) => questions.filter((q) => q.response !== null && q.response !== undefined),
);
